var _excluded = ["href", "size", "underline", "disabled", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './styles';

/**
 * Link
 */
var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var href = _ref.href,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? 'none' : _ref$underline,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var handleClick = React.useCallback(function (e) {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (!href) e.preventDefault();
    onClick && onClick(e);
  }, [href, disabled, onClick]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-testid": "link"
  }, rest, {
    ref: ref,
    href: href,
    size: size,
    underline: underline,
    disabled: disabled,
    onClick: handleClick
  }));
});
Link.displayName = 'Link';
Link.propTypes = {
  href: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  underline: PropTypes.oneOf(['none', 'initial', 'hover', 'always']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
export default Link;
//# sourceMappingURL=index.js.map